import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActions = ({ className = '' }) => {
  const actions = [
    {
      id: 'profile',
      title: 'Update Profile',
      description: 'Manage your specializations and locations',
      icon: 'User',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      href: '/agent-profile'
    },
    {
      id: 'verification',
      title: 'Verification Status',
      description: 'Check your verification progress',
      icon: 'Shield',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      href: '/agent-profile#verification'
    },
    {
      id: 'help',
      title: 'Help & Support',
      description: 'Get help with using the platform',
      icon: 'HelpCircle',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      href: '/help'
    }
  ];

  const handleActionClick = (href) => {
    window.location.href = href;
  };

  return (
    <div className={`bg-card border border-border rounded-lg p-6 ${className}`}>
      <div className="flex items-center space-x-2 mb-4">
        <Icon name="Zap" size={18} className="text-primary" />
        <h2 className="font-semibold text-foreground">Quick Actions</h2>
      </div>
      <div className="space-y-3">
        {actions?.map((action) => (
          <button
            key={action?.id}
            onClick={() => handleActionClick(action?.href)}
            className="w-full flex items-center space-x-3 p-3 rounded-lg hover:bg-muted transition-colors text-left group"
          >
            <div className={`w-10 h-10 ${action?.bgColor} rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-105 transition-transform`}>
              <Icon name={action?.icon} size={18} className={action?.color} />
            </div>
            
            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-medium text-foreground group-hover:text-primary transition-colors">
                {action?.title}
              </h3>
              <p className="text-xs text-muted-foreground line-clamp-1">
                {action?.description}
              </p>
            </div>
            
            <Icon name="ChevronRight" size={16} className="text-muted-foreground group-hover:text-foreground transition-colors" />
          </button>
        ))}
      </div>
      {/* Additional Help Section */}
      <div className="mt-6 pt-4 border-t border-border">
        <div className="text-center">
          <p className="text-xs text-muted-foreground mb-2">
            Need help getting started?
          </p>
          <Button
            variant="outline"
            size="sm"
            onClick={() => window.location.href = '/agent-guide'}
            iconName="BookOpen"
            iconPosition="left"
            iconSize={14}
          >
            View Agent Guide
          </Button>
        </div>
      </div>
    </div>
  );
};

export default QuickActions;